module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/475396997e3882d510b3437585c5014b.svg";